import { Action, createReducer, on } from '@ngrx/store';
import { TrackableItemsActions } from './trackable-items.actions';
import { ItemCategoryType } from "./trackable-item.types";

export const STORE_FEATURE_KEY_TRACKABLE_ITEMS = 'trackableItems';

export class TrackableItemsState {
    loadingIndicator: boolean;
    itemTypes: Array<string>;
    itemCategories: Array<ItemCategoryType>;
    states: Array<string>;
    locationTypes: Array<string>;
    locations: Array<string>;
}

export const initializeReasonsSettingsState: TrackableItemsState = {
  itemTypes:[],
  itemCategories:[],
  locationTypes:[],
  locations:[],
  states: [],
  loadingIndicator: false,
};

const reducer = createReducer(
    initializeReasonsSettingsState,
  on(TrackableItemsActions.getItemTypes, (state, { userId }) =>
    ({ ...state,
      loadingIndicator: true,
    })),
    on(TrackableItemsActions.getItemTypesSuccess, (state, { payload }) =>
        ({ ...state,
          itemTypes: payload.itemType,
           loadingIndicator: false,
        })),
  on(TrackableItemsActions.getItemTypesFail, (state, { error }) =>
    ({ ...state,
      loadingIndicator: false,
    })),
  on(TrackableItemsActions.getItemCategory, (state, { userId }) =>
    ({ ...state,
      loadingIndicator: true,
    })),
  on(TrackableItemsActions.getItemCategorySuccess, (state, { payload }) =>
    ({ ...state,
      itemCategories: payload.itemCategory,
      loadingIndicator: false,
    })),
  on(TrackableItemsActions.getItemCategoryFail, (state, { error }) =>
    ({ ...state,
      loadingIndicator: false,
    })),
  on(TrackableItemsActions.getStates, (state, { userId }) =>
    ({ ...state,
      loadingIndicator: true,
    })),
  on(TrackableItemsActions.getStatesSuccess, (state, { payload }) =>
    ({ ...state,
      states: payload.itemState,
      loadingIndicator: false,
    })),
  on(TrackableItemsActions.getStatesFail, (state, { error }) =>
    ({ ...state,
      loadingIndicator: false,
    })),
  on(TrackableItemsActions.getLocationTypes, (state, { userId }) =>
    ({ ...state,
      loadingIndicator: true,
    })),
  on(TrackableItemsActions.getLocationTypesSuccess, (state, { payload }) =>
    ({ ...state,
      locationTypes: payload.locationType,
      loadingIndicator: false,
    })),
  on(TrackableItemsActions.getItemTypesFail, (state, { error }) =>
    ({ ...state,
      loadingIndicator: false,
    })),
  on(TrackableItemsActions.getLocations, (state, { userId }) =>
    ({ ...state,
      loadingIndicator: true,
    })),
  on(TrackableItemsActions.getLocationsSuccess, (state, { payload }) =>
    ({ ...state,
      locations: payload.location,
      loadingIndicator: false,
    })),
  on(TrackableItemsActions.getLocationsFail, (state, { error }) =>
    ({ ...state,
      loadingIndicator: false,
    })),
);

export function TrackableItemsReducer(state: TrackableItemsState | undefined, action: Action) {
    return reducer(state, action);
}
